import axios from 'axios';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 创建axios实例并设置默认配置
const axiosInstance = axios.create({
  timeout: 300000, // 设置超时时间为5分钟
});

export const fetchData = async (endpoint) => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}/${endpoint}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

// 添加 post 方法
export const postData = async (endpoint, data) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}/${endpoint}`, data);
    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};